<template>
  <div>
    <PageHeader :title="nameTitle" :items="headerItems" />
    <div style="border-radius: 5px; background-color: white; padding: 20px">
      <ReadOnly :componentData="mainData.first" />
      <div class="mt-4" style="border: 1px solid #f0f1f1; border-radius: 5px">
        <b-card-header header-tag="header" class="header" role="tab">
          <b-button @click="arrowToggle()" block v-b-toggle.crypto-details class="w-100 button">
            <div class="inlineButton">
              <div class="buttonTitle">{{ mainData.second.title }}</div>
              <div>
                <i :class="{ down: isToggled, up: !isToggled }"> </i>
              </div>
            </div>
          </b-button>
        </b-card-header>
        <b-collapse id="crypto-details" visible accordion="crypto-details" role="tabpanel">
          <b-card-body>
            <BaseText @input="mainData.second.data.networkPersianName = $event" :value="mainData.second.data.networkPersianName" title="نام فارسی" placeholder="نام فارسی" />
            <BaseText class="mt-3" @input="mainData.second.data.explorer = $event" :value="mainData.second.data.explorer" title="اکسپلورر (URL)" placeholder="اکسپلورر (URL)" />
            <BaseText
              class="mt-3"
              @input="mainData.second.data.persianCoinName = $event"
              :value="mainData.second.data.persianCoinName"
              title="فیلد قبل از شناسه"
              placeholder="فیلد قبل از شناسه"
            />
            <BaseText
              class="mt-3"
              @input="mainData.second.data.persianCoinName = $event"
              :value="mainData.second.data.persianCoinName"
              title="فیلد قبل از آدرس"
              placeholder="فیلد قبل از آدرس"
            />
            <ColorPicker class="mt-3" @input="mainData.second.data.color = $event" labelClass="addColorClass" :value="mainData.second.data.color" title="رنگ" />
            <ColorPicker class="mt-3" @input="mainData.second.data.color = $event" labelClass="addColorClass" :value="mainData.second.data.color" title="رنگ بک گراند" />
            <ComboBox
              class="mt-3"
              @loadMoreData="loadMoreNetwork"
              @searchedItem="mainData.second.data.status"
              :searchedData="mainData.second.data.status"
              @selectedItem="getCategoryChilds($event)"
              :selectedValue="selectedGrandCategory"
              pagination
              placeholder="خرید"
              title="خرید"
            />
            <ComboBox
              class="mt-3"
              @loadMoreData="loadMoreNetwork"
              @searchedItem="mainData.second.data.buyStatus"
              :searchedData="mainData.second.data.buyStatus"
              @selectedItem="getCategoryChilds($event)"
              :selectedValue="selectedGrandCategory"
              pagination
              placeholder="فروش"
              title="فروش"
            />
            <TextAreaInput
              class="mt-3"
              :value="mainData.second.data.buyDescription"
              @input="mainData.second.data.buyDescription = $event"
              title="توضیحات خرید کوین"
              placeholder="توضیحات خرید کوین"
            />
            <TextAreaInput
              class="mt-3"
              :value="mainData.second.data.buyTokenDescription"
              @input="mainData.second.data.buyTokenDescription = $event"
              title="توضیحات خرید توکن"
              placeholder="توضیحات خرید توکن"
            />
            <TextAreaInput
              class="mt-3"
              :value="mainData.second.data.sellDescription"
              @input="mainData.second.data.sellDescription = $event"
              title="توضیحات فروش کوین"
              placeholder="توضیحات فروش کوین"
            />
            <TextAreaInput
              class="mt-3"
              :value="mainData.second.data.sellTokenDescription"
              @input="mainData.second.data.sellTokenDescription = $event"
              title="توضیحات فروش توکن"
              placeholder="توضیحات فروش توکن"
            />
            <div class="button-wrapper mt-3">
              <div @click="goBack()" class="me-2">
                <Button text="انصراف" btnClass="cancel btn-border" />
              </div>
              <div @click="editCryptoNetworkDetails()">
                <Button :loading="companyLoading" text="ثبت" btnClass="aprove-btn btn-border" />
              </div>
            </div>
          </b-card-body>
        </b-collapse>
        <Toast title="با موفقیت ثبت شد" submit :showToast="showToast" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import ReadOnly from '../common/form/type/ReadOnly.vue'
import walletDataProvider from '../../services/wallet'
import BaseText from '../common/form/formModules/BaseText.vue'
import TextAreaInput from '../common/form/formModules/TextAreaInput.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import ColorPicker from '../common/form/formModules/colorPicker.vue'
import Button from '../common/Button.vue'
import Toast from '../common/Toast.vue'

export default {
  name: 'crypto-transaction',
  components: {
    PageHeader,
    ReadOnly,
    BaseText,
    TextAreaInput,
    ComboBox,
    ColorPicker,
    Button,
    Toast,
  },
  data() {
    return {
      mainData: [],
      showToast: false,
    }
  },
  computed: {
    nameTitle() {
      return 'مدیریت شبکه'
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.nameTitle,
          active: true,
        },
      ]
    },
    cryptoId() {
      return this.$route.params.id
    },
  },
  methods: {
    arrowToggle() {
      return (this.isToggled = !this.isToggled)
    },
    editCryptoNetworkDetails() {
      let targetData = {
        network: this.$route.params.id,
        persianName: this.mainData.second.data.networkPersianName,
        color: this.mainData.second.data.color,
        explorer: this.mainData.second.data.explorer,
        sellDescription: this.mainData.second.data.sellDescription,
        buyDescription: this.mainData.second.data.buyDescription,
        sellTokenDescription: this.mainData.second.data.sellTokenDescription,
        buyTokenDescription: this.mainData.second.data.buyTokenDescription,
      }
      walletDataProvider.editCryptoCurrencyNetworkDetail(targetData).then((res) => {
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
        }, 2000)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    getData(payload) {
      walletDataProvider
        .getCryptoNetworkDetails(payload)
        .then((res) => {
          this.mainData = res.data.data
          this.mainData.first.id = '69'
        })
        .catch((err) => console.log(err))
    },
  },
  beforeMount() {
    this.getData({ network: this.$route.params.id })
  },
}
</script>

<style scoped lang="scss">
.team-task-detail-header {
  width: 100%;
  position: sticky;
  top: 60px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8fb;
}
::v-deep .labelStyle {
  min-width: 117px;
  max-width: 117px;
}
::v-deep .collapse .card-body {
  background-color: #ffffff;
}
::v-deep .aprove {
  padding: 3px 14px !important;
}
::v-deep .user-style {
  align-items: center !important;
}
.collapse .card-body {
  background-color: #ffffff;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
.aprove {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.aprove-btn {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.header {
  padding: 0;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  border-radius: 5px 5px 0 0;
  width: 100%;
}
.button {
  padding: 11px 20px;
  box-shadow: none;
  border: none;
  background: #f8f9fa;
}
.labelClass {
  font-size: 10px !important;
}
::v-deep .collapsed {
  outline: none;
  border: none;
  background: #fafafa;
}
::v-deep .card-body {
  padding: 20px !important;
}
.buttonTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.collapse {
  border-top: none;
}
::v-deep .alert {
  padding: 0;
}
.inlineButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
i {
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
</style>
